module.exports = __webpack_public_path__ + "img/img-06.e409d94e.jpg";